import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiChecklist2CheckpointsSectionEditComponent } from './checkpoints-section-edit.component';
import { FiCheckpointGroupComponent } from '@fi-shared/checklist/fi-checklist2-edit/checkpoints-section-edit/checkpoint-group/checkpoint-group.component';
import { FiCheckpointEditComponent } from '@fi-shared/checklist/fi-checklist2-edit/checkpoints-section-edit/checkpoint-edit/checkpoint-edit.component';
import { FiCheckpointEditGeneralTabComponent } from '@fi-shared/checklist/fi-checklist2-edit/checkpoints-section-edit/checkpoint-edit/general-tab/general-tab.component';
import { FiCheckpointTypeEditorComponent } from '@fi-shared/checklist/fi-checklist2-edit/checkpoints-section-edit/checkpoint-edit/general-tab/type-editor/type-editor.component';
import { FiCheckpointScoringEditorComponent } from '@fi-shared/checklist/fi-checklist2-edit/checkpoints-section-edit/checkpoint-edit/general-tab/scoring-editor/scoring-editor.component';
import { FiCheckpointRangesEditorComponent } from '@fi-shared/checklist/fi-checklist2-edit/checkpoints-section-edit/checkpoint-edit/general-tab/ranges-editor/ranges-editor.component';
import { FiCheckpointRangeEditorComponent } from '@fi-shared/checklist/fi-checklist2-edit/checkpoints-section-edit/checkpoint-edit/general-tab/range-editor/range-editor.component';
import { FiTwoColumnsContainerModule } from '../../../fi-two-columns-container/fi-two-columns-container.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatIconModule } from '@angular/material/icon';
import { FiAppTextSharedModule } from '../../../app-text';
import { MatCardModule } from '@angular/material/card';
import { FiIconTooltipButtonModule } from '../../../fi-icon-tooltip-button/fi-icon-tooltip-button.module';
import { MatMenuModule } from '@angular/material/menu';
import { FiValidatingFormModule } from '../../../fi-directives/fi-validating-form/fi-validating-form.module';
import { MatTabsModule } from '@angular/material/tabs';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { FiToggleSwitchModule } from '../../../fi-toggle-switch/fi-toggle-switch.module';
import { InfoIconModule } from '../../../info-icon/info-icon.module';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { FiCheckpointEditConditionsTabComponent } from '@fi-shared/checklist/fi-checklist2-edit/checkpoints-section-edit/checkpoint-edit/conditions-tab/conditions-tab.component';
import { CheckpointEditSummaryComponent } from '@fi-shared/checklist/fi-checklist2-edit/checkpoints-section-edit/checkpoint-edit/checkpoint-edit-summary/checkpoint-edit-summary.component';
import { FiCheckpointEditActionsTabComponent } from '@fi-shared/checklist/fi-checklist2-edit/checkpoints-section-edit/checkpoint-edit/actions-tab/actions-tab.component';
import { FiChecklist2TranslationModule } from '../../fi-checklist2-translation/fi-checklist2-translation.module';
import { FiCheckpointEditConditionsDescriptionComponent } from '@fi-shared/checklist/fi-checklist2-edit/checkpoints-section-edit/checkpoint-edit/conditions-description/conditions-description.component';
import { FiCheckpointConditionComponent } from '@fi-shared/checklist/fi-checklist2-edit/checkpoints-section-edit/checkpoint-edit/conditions-tab/condition/condition.component';
import { FiCheckpointEditActionsDescriptionComponent } from '@fi-shared/checklist/fi-checklist2-edit/checkpoints-section-edit/checkpoint-edit/actions-description/actions-description.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { MatChipsModule } from '@angular/material/chips';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { MatTableModule } from '@angular/material/table';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { FiChecklist2GeneralSectionEditModule } from '@fi-shared/checklist/fi-checklist2-edit/general-section-edit/general-section-edit.module';
import { FiCheckpointActionNotificationEditorDialogComponent } from '@fi-shared/checklist/fi-checklist2-edit/checkpoints-section-edit/checkpoint-edit/actions-tab/action-notification-editor-dialog/action-notification-editor-dialog.component';
import { FiCheckpointActionTaskEditorDialogComponent } from '@fi-shared/checklist/fi-checklist2-edit/checkpoints-section-edit/checkpoint-edit/actions-tab/action-task-editor-dialog/action-task-editor-dialog.component';
import { FiCheckpointActionRecipientComponent } from '@fi-shared/checklist/fi-checklist2-edit/checkpoints-section-edit/checkpoint-edit/actions-tab/action-recipient/action-recipient.component';
import { FiCheckpointActionConditionComponent } from '@fi-shared/checklist/fi-checklist2-edit/checkpoints-section-edit/checkpoint-edit/actions-tab/action-condition/action-condition.component';
import { MatDividerModule } from '@angular/material/divider';
import { FiAttachmentsModule } from '@fi-shared/media-bank/fi-attachments/fi-attachments.module';
import { FiCheckpointActionTaskNameComponent } from '@fi-shared/checklist/fi-checklist2-edit/checkpoints-section-edit/checkpoint-edit/actions-tab/action-task-editor-dialog/action-task-name/action-task-name.component';
import { FiUserContactChipGridInputModule } from '@fi-shared/fi-user-contact-chip-grid-input/fi-user-contact-chip-grid-input.module';
import { FiInputNumberFractionModule } from '@fi-shared/fi-input-number-fraction/fi-input-number-fraction.module';
import { FiErrorMessageModule } from '@fi-shared/fi-error-message';
import { FiCheckpointMeasureUnitEditorComponent } from '@fi-shared/checklist/fi-checklist2-edit/checkpoints-section-edit/checkpoint-edit/general-tab/measure-unit-editor/measure-unit-editor.component';
import { FiAutomatedActionListItemModule } from '@fi-shared/automated-action-list-item/action-list-item.module';
import { FiThreeColumnsContainerModule } from '@fi-shared/fi-three-columns-container/fi-three-columns-container.module';
import { ChecklistAiAssistanceModule } from '@fi-shared/checklist/fi-checklist2-edit/checklist-ai-assistance/checklist-ai-assistance.module';
import { FiTaskV2EditModule } from '@fi-app/task-v2/fi-task-v2-edit/fi-task-v2-edit.module';
import { FiSimpleContenteditableModule } from '@fi-shared/fi-simple-contenteditable/fi-simple-contenteditable.module';
import { FiCheckpointActionTaskDeadlineComponent } from '@fi-shared/checklist/fi-checklist2-edit/checkpoints-section-edit/checkpoint-edit/actions-tab/action-task-editor-dialog/action-task-deadline/action-task-deadline.component';
import { FiNumberOnlyModule } from '@fi-shared/fi-directives/number-only/number-only.module';
import { FiContenteditableModule } from '@fi-shared/fi-contenteditable/fi-contenteditable.module';
import { FiSectionsDndEditorModule } from '@fi-shared/fi-sections-dnd-editor/fi-sections-dnd-editor.module';
import { FiCheckpointGroupItemComponent } from './checkpoint-group/checkpoint-group-item/checkpoint-group-item.component';
import { FiCheckpointGroupScoringComponent } from './checkpoint-group/checkpoint-group-scoring/checkpoint-group-scoring.component';
import { FiInfoBannerModule } from '@fi-shared/fi-info-banner/fi-info-banner.module';
import { FiNameDescriptionInputModule } from '@fi-shared/name-description-input/name-description-input.module';
import { FiNameInputModule } from '@fi-shared/fi-name-input/fi-name-input.module';

@NgModule({
    imports: [
        CommonModule,
        FiTwoColumnsContainerModule,
        DragDropModule,
        MatIconModule,
        FiAppTextSharedModule,
        MatCardModule,
        FiIconTooltipButtonModule,
        MatMenuModule,
        FiValidatingFormModule,
        MatTabsModule,
        MatRadioModule,
        FormsModule,
        FiToggleSwitchModule,
        InfoIconModule,
        MatButtonModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        FiChecklist2TranslationModule,
        MatCheckboxModule,
        SelectSearchModule,
        MatChipsModule,
        FiWrapperTableModule,
        MatTableModule,
        FiProfileIconModule,
        FiChecklist2GeneralSectionEditModule,
        MatDividerModule,
        FiAttachmentsModule,
        FiUserContactChipGridInputModule,
        FiInputNumberFractionModule,
        FiErrorMessageModule,
        FiAutomatedActionListItemModule,
        FiThreeColumnsContainerModule,
        ChecklistAiAssistanceModule,
        FiTaskV2EditModule,
        FiSimpleContenteditableModule,
        FiNumberOnlyModule,
        FiContenteditableModule,
        FiSectionsDndEditorModule,
        FiInfoBannerModule,
        FiNameDescriptionInputModule,
        FiNameInputModule,
    ],
    declarations: [
        FiChecklist2CheckpointsSectionEditComponent,
        FiCheckpointGroupComponent,
        FiCheckpointEditComponent,
        FiCheckpointEditGeneralTabComponent,
        FiCheckpointTypeEditorComponent,
        FiCheckpointMeasureUnitEditorComponent,
        FiCheckpointScoringEditorComponent,
        FiCheckpointRangesEditorComponent,
        FiCheckpointRangeEditorComponent,
        FiCheckpointEditConditionsTabComponent,
        CheckpointEditSummaryComponent,
        FiCheckpointEditActionsTabComponent,
        FiCheckpointEditConditionsDescriptionComponent,
        FiCheckpointConditionComponent,
        FiCheckpointEditActionsDescriptionComponent,
        FiCheckpointActionNotificationEditorDialogComponent,
        FiCheckpointActionTaskEditorDialogComponent,
        FiCheckpointActionConditionComponent,
        FiCheckpointActionRecipientComponent,
        FiCheckpointActionTaskNameComponent,
        FiCheckpointActionTaskDeadlineComponent,
        FiCheckpointGroupItemComponent,
        FiCheckpointGroupScoringComponent,
    ],
    exports: [FiChecklist2CheckpointsSectionEditComponent, FiCheckpointEditComponent],
})
export class FiChecklist2CheckpointSectionEditModule {}
